// removed by extract-text-webpack-plugin
module.exports = {"SensorsData":"SensorsData--27cSG","Container":"Container--immzl"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/SensorsData/SensorsData.scss
// module id = 952
// module chunks = 1